import { cn } from "@/lib/utils";
import Link from "next/link";
import React from "react";

export default function CommunityLink({
  children,
  href,
  className,
  target = "_blank",
}: {
  children: React.ReactNode;
  href: string;
  className?: string;
  target?: string;
}) {
  return (
    <Link
      href={href}
      className={cn(
        "bg-indigo-800/30 p-3 rounded-lg hover:bg-indigo-500 transition-colors shadow-lg hover:shadow-indigo-500/40",
        className
      )}
      target={target}
    >
      {children}
    </Link>
  );
}
